import { Card, CardProps } from '@mui/material';

interface CardDisplayProps extends CardProps {
  children: React.ReactNode;
  disabled?: boolean;
}

const CardDisplay: React.FC<CardDisplayProps> = ({
  elevation = 0,
  disabled,
  onClick,
  children,
  ...cardProps
}) => {
  return (
    <Card
      className='card-display'
      onClick={disabled ? undefined : onClick}
      elevation={elevation}
      {...cardProps}>
      {children}
    </Card>
  );
};

export default CardDisplay;
